import React, { useEffect, createElement } from 'react';
import { StickyBar } from './components/StickyBar';
import { initPixel } from './utils/pixel';
import { HeroSection } from './components/HeroSection';
import { PainPointsSection } from './components/PainPointsSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductSection } from './components/ProductSection';
import { BonusesSection } from './components/BonusesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { BottomCTA } from './components/BottomCTA';
const CHECKOUT_URL = 'https://resinartesanal.store/cart/51954451415353:1';
export function App() {
  useEffect(() => {
    initPixel();
    // SEO title + Open Graph meta for link previews
    document.title = 'Accede con 50% de descuento + 5 bonos 🎁';
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', 'Accede con 50% de descuento + 5 bonos 🎁');
    } else {
      const meta = document.createElement('meta');
      meta.setAttribute('property', 'og:title');
      meta.setAttribute('content', 'Accede con 50% de descuento + 5 bonos 🎁');
      document.head.appendChild(meta);
    }
    // Preconnect + DNS prefetch for instant checkout loading
    const hints = [{
      rel: 'dns-prefetch',
      href: 'https://resinartesanal.store'
    }, {
      rel: 'preconnect',
      href: 'https://resinartesanal.store',
      crossOrigin: 'anonymous'
    }, {
      rel: 'prefetch',
      href: CHECKOUT_URL
    }];
    hints.forEach(({
      rel,
      href,
      crossOrigin
    }) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      if (crossOrigin) link.crossOrigin = crossOrigin;
      document.head.appendChild(link);
    });
  }, []);
  return <div className="min-h-screen bg-white text-body-main selection:bg-[#C9A84C] selection:text-white flex flex-col" data-id="element-0">
      <StickyBar data-id="element-1" />
      <BottomCTA data-id="element-2" />
      <main className="flex-grow" data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPointsSection data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <PricingSection data-id="element-7" />
        <BonusesSection data-id="element-8" />
        <TestimonialsSection data-id="element-9" />
        <FAQSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}